import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { onCategorySearch, onCategoryList } from "../../controller/CategoryController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Card, Form, InputGroup, Table, Pagination, Badge } from 'react-bootstrap';
import { CategoryEntity } from "../../dto/category/CategoryEntity";
import { CategorySearch } from "../../dto/category/CategorySearch";
import { Page } from "../../dto/page/Page";
import { CategoryListEntity } from "../../dto/category/CategoryListEntity";
import SearchIcon from '@mui/icons-material/Search';
import InfoIcon from '@mui/icons-material/Info';
import Select from 'react-select';
import { getCategoryStatus, getYesNo } from "../../app/AppConst";
import { getJSDocTypeParameterTags } from "typescript";

const CategoryList = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!AuthUtility.isUserLoggedIn()) {
            navigate("/login");
            window.location.reload();
        } else {
            categoryListGet();
        }
    }, [])

    // ---- State
    const [search, setSearch] = useState<CategorySearch>({
        limit: 10
    });
    const [categories, setCategories] = useState<CategoryListEntity>({
        data: []
    });
    const [categoryOptions, setCategoryOptions] = useState<Array<Object>>([]);

    const load = async (page: number = 0) => {
        const params: CategorySearch = {
            ...search,
            offset: page
        };

        const response = await onCategorySearch(params);

        if (response.status !== 0) {
            toast.error("Категори уншихад алдаа гарлаа");
            return;
        }

        const pageable = response.data;

        const pageInfo: Page = {
            limit: search.limit,
            totalElements: pageable.totalElements,
            totalPages: pageable.totalPages,
            offset: page
        };

        const beans: Array<CategoryEntity> = pageable.beans;

        setCategories({
            page: pageInfo,
            data: beans
        });

        setSearch(prev => ({ ...prev, offset: page }));
    };

    const categoryListGet = async () => {
        const response = await onCategoryList();
        const cats: Array<CategoryEntity> = response.data.beans;
        const optionArray: Array<Object> = [];
        cats.map((item, index) => {
            var obj = {
                value: item.id + "",
                label: item.name
            }
            optionArray.push(obj);
        })
        setCategoryOptions(optionArray);
    }

    const parentIdsHandler = (value: Object) => {
        var parentIds: Array<number> = Array.isArray(value) ? value.map(x => parseInt(x.value)) : [];
        setSearch({
            ...search,
            parentIds: parentIds
        })
    }

    // ---- Search submit
    const searchSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        load(0); // reset to first page on new search
    };

    // ---- Pagination click
    const changePage = (page: number) => {
        if (!categories.page) return;
        if (page < 0 || page >= categories.page.totalPages) return;
        load(page);
    };

    return (
        <Container fluid>
            <div><Toaster position="top-right" reverseOrder={false}/></div>
            <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Категори</h3>
            <Row className="d-flex justify-content-center align-items-center mb-3">
                <Col md={12} lg={12} xs={12}>
                    <Card>
                        <Card.Header>
                            <Form onSubmit={searchSubmit}>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="top">
                                            <Form.Label className="text-center">Top</Form.Label>
                                            <Form.Select size="sm"
                                                onChange={(event) => {
                                                    const value = event.target.value;

                                                    if (value === "true") {
                                                        setSearch({
                                                            ...search,
                                                            top: true,
                                                        });
                                                    } else if (value === "false") {
                                                        setSearch({
                                                            ...search,
                                                            top: false,
                                                        });
                                                    } else {
                                                        // remove top from state when ""
                                                        const { top, ...rest } = search;
                                                        setSearch(rest);
                                                    }
                                                }}>
                                                <option value=""></option>
                                                <option value="true">Үндсэн</option>
                                                <option value="false">Үндсэн бус</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="name">
                                            <Form.Label className="text-center">Parent Ids</Form.Label>
                                            <Select
                                            options={categoryOptions}
                                            onChange={parentIdsHandler}
                                            isMulti={true}
                                            isClearable={true}
                                            isSearchable={true}
                                            isDisabled={false}
                                            isLoading={false}
                                            isRtl={false}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="name">
                                            <Form.Label className="text-center">Freight</Form.Label>
                                            <Form.Select size="sm"
                                                onChange={(event) => {
                                                    const value = event.target.value;

                                                    if (value === "true") {
                                                    setSearch({
                                                        ...search,
                                                        freightRequiredFlag: true,
                                                    });
                                                    } else if (value === "false") {
                                                    setSearch({
                                                        ...search,
                                                        freightRequiredFlag: false,
                                                    });
                                                    } else {
                                                        // remove top from state when ""
                                                        const { freightRequiredFlag, ...rest } = search;
                                                        setSearch(rest);
                                                    }
                                                }}>
                                                <option value=""></option>
                                                <option value="true">Хүргэлттэй</option>
                                                <option value="false">Хүргэлтгүй</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="offSet">
                                            <Form.Label>Багцлах</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Select size="sm"
                                                    onChange={(event) => setSearch({
                                                        ...search,
                                                        limit: parseInt(event.target.value)
                                                    })}>
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="0">Бүгд</option>
                                                </Form.Select>
                                                <Button variant="primary" size="sm" type="submit">
                                                    <SearchIcon fontSize="small"/>
                                                </Button>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Header>
                        <Card.Body>
                            <Table hover>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Tree</th>
                                        <th>Status</th>
                                        <th>Order</th>
                                        <th>Top</th>
                                        <th>Leaf</th>
                                        <th>Freight</th>
                                        <th><InfoIcon /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categories.data.length === 0 && (
                                        <tr>
                                            <td className="text-muted">
                                                Илэрц олдсонгүй
                                            </td>
                                        </tr>
                                    )}
                                    
                                    {
                                        categories.data.map((data, idx) => {
                                            return (
                                                <tr key={idx}>
                                                    <td>{data.name}</td>
                                                    <td>{data.fullName}</td>
                                                    <td>
                                                        <Badge bg={getCategoryStatus(data.status)}>{data.status}</Badge>
                                                    </td>
                                                    <td>{data.sortOrder}</td>
                                                    <td>
                                                        <Badge bg={getYesNo(data.onWebTop)}>{data.onWebTop ? "YES" : "NO"}</Badge>
                                                    </td>
                                                    <td>
                                                        <Badge bg={getYesNo(data.leafFlag)}>{data.leafFlag ? "YES" : "NO"}</Badge>
                                                    </td>
                                                    <td>
                                                        <Badge bg={getYesNo(data.freightRequiredFlag)}>{data.freightRequiredFlag ? "YES" : "NO"}</Badge>
                                                    </td>
                                                    <th><a href={`/category/${data.id}`}><InfoIcon /></a></th>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>  
            </Row>

            {categories.page && categories.page.totalPages > 1 && (() => {
                const page = categories.page;   // now TypeScript knows it's NOT undefined

                return (
                    <Row>
                        <Col className="d-flex justify-content-start">
                            <Pagination>
                                <Pagination.First
                                    disabled={page.offset === 0}
                                    onClick={() => changePage(0)}
                                />

                                <Pagination.Prev
                                    disabled={page.offset === 0}
                                    onClick={() => changePage(page.offset - 1)}
                                />

                                {Array.from({ length: page.totalPages })
                                    .slice(
                                        Math.max(page.offset - 2, 0),
                                        Math.min(page.offset + 3, page.totalPages)
                                    )
                                    .map((_, idx) => {
                                        const pageNumber =
                                            Math.max(page.offset - 2, 0) + idx;

                                        return (
                                            <Pagination.Item
                                                key={pageNumber}
                                                active={pageNumber === page.offset}
                                                onClick={() => changePage(pageNumber)}
                                            >
                                                {pageNumber + 1}
                                            </Pagination.Item>
                                        );
                                    })}

                                <Pagination.Next
                                    disabled={page.offset + 1 >= page.totalPages}
                                    onClick={() => changePage(page.offset + 1)}
                                />

                                <Pagination.Last
                                    disabled={page.offset + 1 >= page.totalPages}
                                    onClick={() => changePage(page.totalPages - 1)}
                                />
                            </Pagination>
                        </Col>
                    </Row>
                );
            })()}
        </Container>
    )
}

export default CategoryList;